import React, { Component } from 'react';
import './style.css';
import {Link} from 'react-router-dom';
import Icon from 'react-icons-kit';
import {androidDelete} from 'react-icons-kit/ionicons/androidDelete';
import {eye} from 'react-icons-kit/ionicons/eye';

class UserDemographicsCategoriesList extends Component {
  constructor(props){
    super(props)

    this.queryString = window.location.href;
    this.uid =this.queryString.split('&UID=')[1];  //participant id 
    this.state = {
        uid: this.uid,
    }
  }

  
  userDemoQuestionsAnsList(data){
    this.props.showDataDemographics(data.cat_id , this.state.uid)
  }

  goBackScreen(){
    window.history.back();
  }


  render(){

    let couponsDataList = "";
    if(this.props.demoGraphicsCategoriesListSuccess){
    if(this.props.demoGraphicsCategoriesList && this.props.demoGraphicsCategoriesList.length > 0){
        let categories = this.props.demoGraphicsCategoriesList;
        couponsDataList = Object.keys(categories).map((item, index) => {
        let categoryItem = categories[item];

        return <tr key={index} >
            <td style ={{ textAlign : "center" }}>{index+1}</td>
            <td style ={{ textAlign : "center" }}>{categoryItem.cat_id}</td>
            <td>{categoryItem.catName}</td>
            <td style ={{ textAlign : "center" }}>{categoryItem.order_no}</td>
            <td className = "cat_action">
            
            <button onClick = {this.userDemoQuestionsAnsList.bind(this, categoryItem)} className = "removebutton">
            < Icon icon={eye} size={30} style={{ color: '#337ab7' }}/></button>
            
            </td>
          </tr>
          });
    }else{
        couponsDataList = "No data"
    }
  }

  return (<div className = "userlist">
  <div className = "userlistbackground">
        <div className = "usertable"><h1>Demographics Categories List</h1></div>
        <button  className = "backbutton" onClick={this.goBackScreen}>Back</button>
        <div className = "autoscroll">
        <table className = "demoategoryTable">
          <thead>
            <tr >
              <th>Sr.No.</th>
              <th>Category</th>
              <th>Name</th>
              <th>Order No.</th>
              <th>Action</th> 
            </tr>
          </thead>
            <tbody> 
              {couponsDataList}  
            </tbody>
        </table>
        </div>
        </div>
        </div>
        
    );
  }
}
export default UserDemographicsCategoriesList;



// WEBPACK FOOTER //
// ./src/components/country/userDemographics.js